import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
// Lazy load components below the fold to improve initial load time
const TrustBar = lazy(() => import('./components/TrustBar').then(module => ({
  default: module.TrustBar
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(module => ({
  default: module.ProblemSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(module => ({
  default: module.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(module => ({
  default: module.BonusSection
})));
const ForWhoSection = lazy(() => import('./components/ForWhoSection').then(module => ({
  default: module.ForWhoSection
})));
const TimelineSection = lazy(() => import('./components/TimelineSection').then(module => ({
  default: module.TimelineSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(module => ({
  default: module.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(module => ({
  default: module.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('./TestimonialsSection').then(module => ({
  default: module.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(module => ({
  default: module.FinalCTASection
})));
const Footer = lazy(() => import('./components/Footer').then(module => ({
  default: module.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(module => ({
  default: module.SocialProofPopup
})));
export function App() {
  useEffect(() => {
    // Preload Google Fonts non-blocking (preconnects handled in index.html)
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = () => {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Meta Pixel - deferred to avoid blocking render
    let pixelScript: HTMLScriptElement | null = null;
    let noscript: HTMLElement | null = null;
    const pixelTimeout = setTimeout(() => {
      pixelScript = document.createElement('script');
      pixelScript.async = true;
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '947072064512852');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);
      noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=947072064512852&ev=PageView&noscript=1" alt="" />`;
      document.body.appendChild(noscript);
    }, 3500);
    return () => {
      clearTimeout(pixelTimeout);
      document.head.removeChild(fontLink);
      if (pixelScript) document.head.removeChild(pixelScript);
      if (noscript) document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen font-sans selection:bg-blue-500 selection:text-white bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={<div className="min-h-[200px] bg-white" data-id="element-5" />} data-id="element-4">
          <TrustBar data-id="element-6" />
          <ProblemSection data-id="element-7" />
          <TomosSection data-id="element-8" />
          <BonusSection data-id="element-9" />
          <ForWhoSection data-id="element-10" />
          <TimelineSection data-id="element-11" />
          <PricingSection data-id="element-12" />
          <GuaranteeSection data-id="element-13" />
          <TestimonialsSection data-id="element-14" />
          <FAQSection data-id="element-15" />
          <FinalCTASection data-id="element-16" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-17">
        <Footer data-id="element-18" />
        <SocialProofPopup data-id="element-19" />
      </Suspense>
    </div>;
}